// components/UsageIcon.js
import React from "react";

const UsageIcon = ({ type, active = false, size = 24 , fillColor = "#d51b81"}) => {
  const color = active ? fillColor : "#929292";
  const strokeWidth = 1.2;

  // Minimal person: filled head + outlined body
const Person = ({ cx, cy, scale = 1 }) => {
  const headR = 1.2 * scale;
  const bodyOffsetX = 2 * scale;
  const bodyOffsetY = 3 * scale;
  const bodyCurveY = 1.5 * scale;

  return (
    <>
      {/* Head */}
      <circle cx={cx} cy={cy} r={headR} fill={color} />
      {/* Body */}
      <path
        d={`M${cx - bodyOffsetX} ${cy + bodyOffsetY} Q ${cx} ${cy + bodyCurveY} ${cx + bodyOffsetX} ${cy + bodyOffsetY}`}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
    </>
  );
};

  const getIconPath = () => {
    switch (type) {
case "meeting_room":
  return (
    <>
      {/* Three people */}
      <Person cx={8} cy={15} />
      <Person cx={16} cy={15} />
      <Person cx={12} cy={9} />

      {/* Speech bubbles */}
      <path
        d="M6 5.5h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8l-2 1v-1.5a2 2 0 0 1-2-2v-0.5a2 2 0 0 1 2-2z"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 4.5h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2l-2 1v-1.5a2 2 0 0 1-2-2v-0.5a2 2 0 0 1 2-2z"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );




      case "seminar":
        return (
          <>
            <rect
              x="4"
              y="6"
              width="16"
              height="4"
              rx="1"
              stroke={color}
              strokeWidth={strokeWidth}
              fill="none"
            />
            <Person cx={8} cy={13.5} />
            <Person cx={12} cy={13.5} />
            <Person cx={16} cy={13.5} />
          </>
        );

      case "coworking":
        return (
          <>
            {/* Keep original coworking design */}
            <rect x="6" y="6" width="5" height="5" rx="1" stroke={color} strokeWidth={strokeWidth} fill="none" />
            <rect x="13" y="6" width="5" height="5" rx="1" stroke={color} strokeWidth={strokeWidth} fill="none" />
            <rect x="6" y="13" width="5" height="5" rx="1" stroke={color} strokeWidth={strokeWidth} fill="none" />
            <rect x="13" y="13" width="5" height="5" rx="1" stroke={color} strokeWidth={strokeWidth} fill="none" />
          </>
        );

     case "shared_office":
  return (
    <>
      <Person cx={8} cy={12} scale={1.3} />
      <Person cx={12} cy={12}scale={1.6}  />
      <Person cx={16} cy={12} scale={1.3} />
    </>
  );


    case "private_office":
  return (
    <>
      {/* Large single person, fills most of icon */}
      <Person cx={12} cy={11} scale={2.2} />
      {/* Circle showing private space */}
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </>
  );


case "teambuilding":
  return (
    <>
      {/* Three people in a triangle */}
      <Person cx={12} cy={4} scale={1.4} />       {/* Top */}
      <Person cx={6} cy={18} scale={1.4} />       {/* Bottom left */}
      <Person cx={18} cy={18} scale={1.4} />      {/* Bottom right */}

      {/* Star in the center */}
      <path
        d="M12 9.5 L13.2 12 H16 L13.9 13.6 L14.6 16 L12 14.5 L9.4 16 L10.1 13.6 L8 12 H10.8 Z"
        fill={color}
      />
    </>
  );



      case "conference_room":
        return (
          <>
            <rect x="8" y="9" width="8" height="6" rx="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
            <Person cx={5.5} cy={10.5} />
            <Person cx={18.5} cy={10.5} />
            <Person cx={12} cy={7} />
            <Person cx={12} cy={17} />
          </>
        );

      default:
        return (
          <>
            <circle cx="12" cy="12" r="8" stroke={color} strokeWidth={strokeWidth} fill="none" />
            <line x1="8" y1="8" x2="16" y2="16" stroke={color} strokeWidth={strokeWidth} />
            <line x1="8" y1="16" x2="16" y2="8" stroke={color} strokeWidth={strokeWidth} />
          </>
        );
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={`${type} icon`}
    >
      {getIconPath()}
    </svg>
  );
};

export default UsageIcon;
